import { useParams } from "react-router-dom";

import { TOUR_DISMISSAL } from "./constants";
import type { TourDefinition } from "./types";
import { useTourDismissal } from "./useTourDismissal";
import { useTourState } from "./useTourState";

import { useAuth } from "@/lib/hooks/useAuth";

export function useTourPromo(definition: TourDefinition) {
  const { clientId } = useParams();
  const { context } = useAuth();
  const { showPromo } = useTourState(definition);
  const [isCardDismissed, dismissCard] = useTourDismissal(definition.id, TOUR_DISMISSAL.HOME_CARD);
  const [isBannerDismissed, dismissBanner] = useTourDismissal(definition.id, TOUR_DISMISSAL.BANNER);

  const hasClientScope = context !== "admin" || Boolean(clientId);

  return {
    isActive: showPromo && hasClientScope,
    isCardDismissed,
    isBannerDismissed,
    dismissCard,
    dismissBanner,
  };
}
